import { formField } from '@epages/react-components'
import { forwardRef, useState } from 'react'

import { useTranslate } from '../../utils/translate'
import CodeEditor from './CodeEditor'

const codeMirrorOptions = {
  lineNumbers: true,
  lineWrapping: true,
  mode: 'htmlmixed',
  theme: 'base16-light',
  viewportMargin: Infinity,
  lint: true,
}

type CustomHtmlFieldProps = Readonly<{
  value: string
  onChange: (value: string) => void
  onEditorResize?: () => void
  onInput?: () => void
  resetValue: string
}>

// Use `ForwardRef` to avoid "Function components cannot be given refs"
// React warning (which is caused by the `react-components` "formField" HOC).
export const CustomHtmlField = forwardRef<HTMLElement, CustomHtmlFieldProps>(({ value, onChange }, _ref) => {
  const [currentValue, setCurrentValue] = useState(value)
  const [invalid, setInvalid] = useState(false)

  const t = useTranslate('interface')

  return (
    <CodeEditor
      value={currentValue}
      resetValue=""
      invalid={invalid}
      className="ep-custom-html-field"
      warningDismissKey="customHtmlWarningDismissed"
      tScoped={(subKey, ...args) => t(`components.freeHtmlElementComponent.${subKey}`, ...args)}
      onChange={(newValue) => setCurrentValue(newValue)}
      onLint={(lintingErrors, editorValue) => {
        if (lintingErrors.length === 0) {
          onChange(editorValue)
        }

        setInvalid(lintingErrors.length !== 0)
      }}
      codeMirrorOptions={codeMirrorOptions}
    />
  )
})

CustomHtmlField.displayName = 'CustomHtmlField'

export default formField()(CustomHtmlField)
